module.exports = __webpack_public_path__ + "img/parcours.51a73322.png";